/**
 * Year 12 ICT - Unit Tests, Exercises, and Assignments
 * Complete assessment materials for all 16 units
 */

// ============================================
// TEST BLUEPRINTS
// ============================================
export const year12ICTTestBlueprints = {
  unit1: {
    unitTitle: "Unit 1: PC Hardware Components",
    duration: "45 minutes",
    totalMarks: 40,
    slosCovered: ["12ICT1.1.1.1", "12ICT1.1.2.1", "12ICT1.1.2.2", "12ICT1.1.2.3"],
    breakdown: {
      multipleChoice: { count: 15, marks: 15, percentage: 37.5 },
      shortAnswer: { count: 5, marks: 15, percentage: 37.5 },
      extendedResponse: { count: 1, marks: 10, percentage: 25 }
    },
    cognitiveLevel: {
      knowledge: "40%",
      comprehension: "30%",
      application: "20%",
      analysis: "10%"
    }
  },
  unit2: {
    unitTitle: "Unit 2: Building a PC",
    duration: "45 minutes",
    totalMarks: 40,
    slosCovered: ["12ICT1.1.3.1", "12ICT1.1.4.1", "12ICT1.1.1.2", "12ICT1.1.2.7"],
    breakdown: {
      multipleChoice: { count: 10, marks: 10, percentage: 25 },
      shortAnswer: { count: 4, marks: 12, percentage: 30 },
      extendedResponse: { count: 1, marks: 10, percentage: 25 },
      practical: { count: 1, marks: 8, percentage: 20 }
    },
    cognitiveLevel: {
      knowledge: "25%",
      comprehension: "25%",
      application: "35%",
      analysis: "15%"
    }
  },
  unit3: {
    unitTitle: "Unit 3: Operating System Installation",
    duration: "45 minutes",
    totalMarks: 40,
    slosCovered: ["12ICT1.1.1.3", "12ICT1.1.1.4", "12ICT1.1.2.4", "12ICT1.1.3.2", "12ICT1.1.1.5"],
    breakdown: {
      multipleChoice: { count: 12, marks: 12, percentage: 30 },
      shortAnswer: { count: 5, marks: 15, percentage: 37.5 },
      extendedResponse: { count: 1, marks: 13, percentage: 32.5 }
    },
    cognitiveLevel: {
      knowledge: "30%",
      comprehension: "35%",
      application: "25%",
      analysis: "10%"
    }
  },
  unit5: {
    unitTitle: "Unit 5: Advanced Word Processing",
    duration: "45 minutes",
    totalMarks: 40,
    slosCovered: ["12ICT2.1.1.1", "12ICT2.1.2.1", "12ICT2.1.2.2", "12ICT2.1.2.3", "12ICT2.1.2.4", "12ICT2.1.3.1"],
    breakdown: {
      multipleChoice: { count: 12, marks: 12, percentage: 30 },
      shortAnswer: { count: 4, marks: 12, percentage: 30 },
      practical: { count: 1, marks: 16, percentage: 40 }
    },
    cognitiveLevel: {
      knowledge: "25%",
      comprehension: "30%",
      application: "35%",
      analysis: "10%"
    }
  },
  unit6: {
    unitTitle: "Unit 6: Mail Merge & Citations",
    duration: "45 minutes",
    totalMarks: 35,
    slosCovered: ["12ICT2.1.1.22", "12ICT2.1.2.11", "12ICT2.1.3.4", "12ICT2.1.1.16", "12ICT2.1.2.9"],
    breakdown: {
      multipleChoice: { count: 10, marks: 10, percentage: 28.5 },
      shortAnswer: { count: 4, marks: 10, percentage: 28.5 },
      practical: { count: 1, marks: 15, percentage: 43 }
    },
    cognitiveLevel: {
      knowledge: "30%",
      comprehension: "25%",
      application: "40%",
      analysis: "5%"
    }
  },
  unit7: {
    unitTitle: "Unit 7: Spreadsheet Fundamentals",
    duration: "45 minutes",
    totalMarks: 40,
    slosCovered: ["12ICT2.2.1.1", "12ICT2.2.1.2", "12ICT2.2.2.1", "12ICT2.2.1.4", "12ICT2.2.2.3", "12ICT2.2.1.6", "12ICT2.2.2.6"],
    breakdown: {
      multipleChoice: { count: 10, marks: 10, percentage: 25 },
      shortAnswer: { count: 4, marks: 12, percentage: 30 },
      practical: { count: 1, marks: 18, percentage: 45 }
    },
    cognitiveLevel: {
      knowledge: "25%",
      comprehension: "25%",
      application: "40%",
      analysis: "10%"
    }
  },
  unit8: {
    unitTitle: "Unit 8: Charts & Data Analysis",
    duration: "45 minutes",
    totalMarks: 35,
    slosCovered: ["12ICT2.2.1.11", "12ICT2.2.2.11", "12ICT2.2.3.2", "12ICT2.2.4.2"],
    breakdown: {
      multipleChoice: { count: 8, marks: 8, percentage: 23 },
      shortAnswer: { count: 4, marks: 12, percentage: 34 },
      practical: { count: 1, marks: 15, percentage: 43 }
    },
    cognitiveLevel: {
      knowledge: "20%",
      comprehension: "30%",
      application: "35%",
      analysis: "15%"
    }
  },
  unit9: {
    unitTitle: "Unit 9: Database Fundamentals",
    duration: "45 minutes",
    totalMarks: 40,
    slosCovered: ["12ICT2.3.1.1", "12ICT2.3.2.1", "12ICT2.3.1.8", "12ICT2.3.2.3", "12ICT2.3.1.13", "12ICT2.3.2.6"],
    breakdown: {
      multipleChoice: { count: 12, marks: 12, percentage: 30 },
      shortAnswer: { count: 5, marks: 15, percentage: 37.5 },
      extendedResponse: { count: 1, marks: 13, percentage: 32.5 }
    },
    cognitiveLevel: {
      knowledge: "30%",
      comprehension: "35%",
      application: "25%",
      analysis: "10%"
    }
  },
  unit10: {
    unitTitle: "Unit 10: Forms, Queries & Reports",
    duration: "45 minutes",
    totalMarks: 40,
    slosCovered: ["12ICT2.3.1.18", "12ICT2.3.2.10", "12ICT2.3.1.19", "12ICT2.3.2.12", "12ICT2.3.3.4", "12ICT2.3.1.20"],
    breakdown: {
      multipleChoice: { count: 10, marks: 10, percentage: 25 },
      shortAnswer: { count: 4, marks: 12, percentage: 30 },
      practical: { count: 1, marks: 18, percentage: 45 }
    },
    cognitiveLevel: {
      knowledge: "25%",
      comprehension: "25%",
      application: "40%",
      analysis: "10%"
    }
  },
  unit11: {
    unitTitle: "Unit 11: Digital Image Processing",
    duration: "45 minutes",
    totalMarks: 35,
    slosCovered: ["12ICT3.3.1.1", "12ICT3.3.2.1", "12ICT3.3.1.2", "12ICT3.3.2.2", "12ICT3.3.1.3", "12ICT3.3.2.3", "12ICT3.3.3.2"],
    breakdown: {
      multipleChoice: { count: 10, marks: 10, percentage: 28.5 },
      shortAnswer: { count: 4, marks: 10, percentage: 28.5 },
      practical: { count: 1, marks: 15, percentage: 43 }
    },
    cognitiveLevel: {
      knowledge: "30%",
      comprehension: "30%",
      application: "30%",
      analysis: "10%"
    }
  },
  unit12: {
    unitTitle: "Unit 12: Programming Fundamentals",
    duration: "45 minutes",
    totalMarks: 40,
    slosCovered: ["12ICT1.3.1.1", "12ICT1.3.2.1", "12ICT1.3.1.3", "12ICT1.3.1.4", "12ICT1.3.1.5", "12ICT1.3.1.15", "12ICT1.3.2.7"],
    breakdown: {
      multipleChoice: { count: 10, marks: 10, percentage: 25 },
      shortAnswer: { count: 4, marks: 12, percentage: 30 },
      codingTask: { count: 2, marks: 18, percentage: 45 }
    },
    cognitiveLevel: {
      knowledge: "25%",
      comprehension: "25%",
      application: "40%",
      analysis: "10%"
    }
  },
  unit13: {
    unitTitle: "Unit 13: Computer Networks",
    duration: "45 minutes",
    totalMarks: 40,
    slosCovered: ["12ICT4.1.1.1", "12ICT4.1.2.1", "12ICT4.1.3.1", "12ICT4.1.1.4", "12ICT4.1.2.4", "12ICT4.1.1.7", "12ICT4.1.2.6"],
    breakdown: {
      multipleChoice: { count: 12, marks: 12, percentage: 30 },
      shortAnswer: { count: 5, marks: 15, percentage: 37.5 },
      extendedResponse: { count: 1, marks: 13, percentage: 32.5 }
    },
    cognitiveLevel: {
      knowledge: "35%",
      comprehension: "30%",
      application: "25%",
      analysis: "10%"
    }
  },
  unit14: {
    unitTitle: "Unit 14: Web Page Creation",
    duration: "45 minutes",
    totalMarks: 40,
    slosCovered: ["12ICT4.2.1.1", "12ICT4.2.1.4", "12ICT4.2.2.3", "12ICT4.2.1.7", "12ICT4.2.1.8", "12ICT4.2.2.5", "12ICT4.2.3.1"],
    breakdown: {
      multipleChoice: { count: 10, marks: 10, percentage: 25 },
      shortAnswer: { count: 4, marks: 12, percentage: 30 },
      practical: { count: 1, marks: 18, percentage: 45 }
    },
    cognitiveLevel: {
      knowledge: "25%",
      comprehension: "25%",
      application: "40%",
      analysis: "10%"
    }
  },
  unit15: {
    unitTitle: "Unit 15: Internet Security & Safety",
    duration: "45 minutes",
    totalMarks: 40,
    slosCovered: ["12ICT4.3.1.2", "12ICT4.3.2.2", "12ICT4.3.3.1", "12ICT4.3.4.1", "12ICT4.3.1.5", "12ICT4.3.2.4", "12ICT4.3.3.3"],
    breakdown: {
      multipleChoice: { count: 12, marks: 12, percentage: 30 },
      shortAnswer: { count: 5, marks: 15, percentage: 37.5 },
      extendedResponse: { count: 1, marks: 13, percentage: 32.5 }
    },
    cognitiveLevel: {
      knowledge: "30%",
      comprehension: "30%",
      application: "25%",
      analysis: "15%"
    }
  }
};

// ============================================
// UNIT TESTS WITH ANSWER KEYS
// ============================================
export const year12ICTUnitTests = {
  // ==========================================
  // UNIT 1: PC Hardware Components
  // ==========================================
  unit1: {
    id: "y12ict-unit1-test",
    title: "Unit 1 Test: PC Hardware Components",
    duration: "45 minutes",
    totalMarks: 40,
    instructions: [
      "Answer ALL questions",
      "Write your answers clearly",
      "Multiple choice: Circle the correct answer"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 15,
        questions: [
          { id: 1, question: "The CPU is also known as the:", options: ["A. Brain of the computer", "B. Heart of the computer", "C. Memory of the computer", "D. Storage of the computer"], answer: "A", marks: 1 },
          { id: 2, question: "Which component temporarily stores data for quick access by the CPU?", options: ["A. Hard Drive", "B. SSD", "C. RAM", "D. ROM"], answer: "C", marks: 1 },
          { id: 3, question: "The motherboard's main function is to:", options: ["A. Store files permanently", "B. Connect all components together", "C. Display images", "D. Provide internet connection"], answer: "B", marks: 1 },
          { id: 4, question: "Which port is commonly used for connecting monitors?", options: ["A. USB", "B. Ethernet", "C. HDMI", "D. Audio Jack"], answer: "C", marks: 1 },
          { id: 5, question: "SATA cables are used to connect:", options: ["A. Monitors", "B. Storage devices", "C. Keyboards", "D. Speakers"], answer: "B", marks: 1 },
          { id: 6, question: "The power supply unit (PSU) converts:", options: ["A. DC to AC", "B. AC to DC", "C. Analog to digital", "D. Digital to analog"], answer: "B", marks: 1 },
          { id: 7, question: "Which is NOT a type of RAM?", options: ["A. DDR4", "B. DDR5", "C. SDRAM", "D. HDRAM"], answer: "D", marks: 1 },
          { id: 8, question: "The graphics card is responsible for:", options: ["A. Sound processing", "B. Image rendering", "C. Network connections", "D. File storage"], answer: "B", marks: 1 },
          { id: 9, question: "USB stands for:", options: ["A. Universal Serial Bus", "B. United System Board", "C. Universal System Bus", "D. United Serial Board"], answer: "A", marks: 1 },
          { id: 10, question: "Which component cools the CPU?", options: ["A. RAM", "B. PSU", "C. Heatsink and fan", "D. GPU"], answer: "C", marks: 1 },
          { id: 11, question: "An SSD is faster than an HDD because it:", options: ["A. Has more storage", "B. Uses flash memory with no moving parts", "C. Is larger in size", "D. Uses more power"], answer: "B", marks: 1 },
          { id: 12, question: "The RJ-45 connector is used for:", options: ["A. Power cables", "B. Video cables", "C. Network cables", "D. Audio cables"], answer: "C", marks: 1 },
          { id: 13, question: "BIOS is stored in:", options: ["A. RAM", "B. Hard Drive", "C. ROM chip on motherboard", "D. CPU cache"], answer: "C", marks: 1 },
          { id: 14, question: "Which bus connects the CPU to RAM?", options: ["A. USB", "B. Memory bus", "C. SATA bus", "D. Audio bus"], answer: "B", marks: 1 },
          { id: 15, question: "A 500W PSU means:", options: ["A. It weighs 500 watts", "B. It can deliver up to 500 watts of power", "C. It uses 500 watts constantly", "D. It costs 500 dollars"], answer: "B", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 15,
        questions: [
          { id: 16, question: "List FIVE major internal components of a PC.", marks: 5, answer: "CPU, RAM, Motherboard, Hard Drive/SSD, Power Supply Unit, Graphics Card (any 5)" },
          { id: 17, question: "Explain the difference between RAM and ROM.", marks: 4, answer: "RAM (Random Access Memory) is volatile memory that temporarily stores data while the computer is running and loses data when power is off. ROM (Read Only Memory) is non-volatile memory that permanently stores essential boot instructions and retains data even without power." },
          { id: 18, question: "Name THREE common PC ports and their uses.", marks: 3, answer: "USB - connecting peripherals like keyboard, mouse, flash drives; HDMI - connecting monitors and displays; Ethernet/RJ-45 - network connection; Audio jack - speakers/headphones (any 3)" },
          { id: 19, question: "What is the purpose of thermal paste?", marks: 3, answer: "Thermal paste fills microscopic gaps between the CPU and heatsink, improving heat transfer from the CPU to the cooling system, preventing overheating." }
        ]
      },
      {
        name: "Section C: Extended Response",
        marks: 10,
        questions: [
          { id: 20, question: "A friend wants to upgrade their old computer for gaming. Explain which THREE components they should prioritize upgrading and why each is important for gaming performance.", marks: 10, answer: "1. Graphics Card (GPU) - Most important for gaming as it renders all game visuals, higher-end GPUs provide better frame rates and image quality. 2. RAM - Games require significant memory; upgrading to at least 16GB allows smooth multitasking and prevents stuttering during gameplay. 3. Storage (SSD) - Installing games on an SSD dramatically reduces load times compared to HDD. Additional considerations: CPU for processing game logic, PSU to support upgraded components." }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 2: Building a PC
  // ==========================================
  unit2: {
    id: "y12ict-unit2-test",
    title: "Unit 2 Test: Building a PC",
    duration: "45 minutes",
    totalMarks: 40,
    instructions: [
      "Answer ALL questions",
      "Write your answers clearly",
      "Section D requires practical demonstration"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 10,
        questions: [
          { id: 1, question: "Before handling PC components, you should:", options: ["A. Wash hands with water", "B. Ground yourself to prevent static", "C. Wear rubber gloves", "D. Work on carpet"], answer: "B", marks: 1 },
          { id: 2, question: "The CPU is installed on the:", options: ["A. RAM slot", "B. PCIe slot", "C. CPU socket", "D. SATA port"], answer: "C", marks: 1 },
          { id: 3, question: "RAM modules have a notch to:", options: ["A. Improve airflow", "B. Ensure correct orientation", "C. Reduce weight", "D. Increase speed"], answer: "B", marks: 1 },
          { id: 4, question: "Which component should be installed FIRST when building a PC?", options: ["A. Graphics card", "B. Hard drive", "C. CPU on motherboard", "D. Case fans"], answer: "C", marks: 1 },
          { id: 5, question: "The 24-pin connector provides power to the:", options: ["A. CPU only", "B. GPU only", "C. Motherboard", "D. Hard drive"], answer: "C", marks: 1 },
          { id: 6, question: "Standoffs are used to:", options: ["A. Connect cables", "B. Prevent motherboard from touching the case", "C. Cool the CPU", "D. Store screws"], answer: "B", marks: 1 },
          { id: 7, question: "POST stands for:", options: ["A. Power On Self Test", "B. Primary Operating System Test", "C. Processor Output Signal Test", "D. Power Output System Test"], answer: "A", marks: 1 },
          { id: 8, question: "The I/O shield is installed:", options: ["A. Inside the PSU", "B. On the back of the case before the motherboard", "C. On top of the CPU", "D. Inside the RAM slots"], answer: "B", marks: 1 },
          { id: 9, question: "When installing the CPU cooler, you should apply thermal paste:", options: ["A. In thick layers covering entire CPU", "B. A pea-sized amount in the center", "C. Only on the corners", "D. No paste is needed"], answer: "B", marks: 1 },
          { id: 10, question: "If the PC doesn't power on, the FIRST thing to check is:", options: ["A. The graphics card", "B. Power connections and PSU switch", "C. The RAM speed", "D. The mouse"], answer: "B", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 12,
        questions: [
          { id: 11, question: "List the correct ORDER for installing the following components: Graphics Card, CPU, RAM, Power Supply, Motherboard in case.", marks: 4, answer: "1. Install CPU on motherboard (outside case), 2. Install RAM on motherboard, 3. Install motherboard in case, 4. Install Power Supply in case, 5. Install Graphics Card" },
          { id: 12, question: "Explain TWO safety precautions when building a PC.", marks: 4, answer: "1. Use an anti-static wrist strap or touch the case to ground yourself before handling components to prevent electrostatic discharge (ESD) damage. 2. Work on a clean, non-conductive surface (not carpet) and unplug the PSU when installing components." },
          { id: 13, question: "What should you do if the computer beeps repeatedly during POST?", marks: 4, answer: "Repeated beeps indicate a hardware error. Listen to the beep pattern and consult the motherboard manual to identify the issue. Common causes include: improperly seated RAM (reseat RAM modules), missing/failed graphics card, CPU issues. Check all connections and components are properly installed." }
        ]
      },
      {
        name: "Section C: Extended Response",
        marks: 10,
        questions: [
          { id: 14, question: "Describe the complete process of installing a CPU and its cooler on a motherboard. Include all steps and precautions.", marks: 10, answer: "1. Ground yourself using anti-static wrist strap. 2. Open CPU socket by lifting the retention arm. 3. Align CPU with socket using the golden triangle/notches. 4. Gently place CPU in socket without forcing. 5. Lower retention arm to secure CPU. 6. Apply pea-sized amount of thermal paste on CPU center. 7. Position cooler over CPU, aligning mounting holes. 8. Secure cooler using appropriate mounting mechanism (push pins, screws, or brackets). 9. Connect CPU fan header to motherboard. 10. Verify cooler is firmly attached with no wobble." }
        ]
      },
      {
        name: "Section D: Practical Task",
        marks: 8,
        questions: [
          { id: 15, question: "Demonstrate the proper installation of a RAM module into a motherboard. Teacher will observe and mark based on: correct slot selection, proper orientation, secure installation, and safety practices.", marks: 8, answer: "Marking criteria: Identifies correct slot (2 marks), Aligns notch correctly (2 marks), Applies even pressure until clips click (2 marks), Uses anti-static precautions (2 marks)" }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 3: Operating System Installation
  // ==========================================
  unit3: {
    id: "y12ict-unit3-test",
    title: "Unit 3 Test: Operating System Installation",
    duration: "45 minutes",
    totalMarks: 40,
    instructions: [
      "Answer ALL questions",
      "Write your answers clearly"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 12,
        questions: [
          { id: 1, question: "An operating system is:", options: ["A. A hardware component", "B. Software that manages computer resources", "C. A type of virus", "D. A programming language"], answer: "B", marks: 1 },
          { id: 2, question: "Which is NOT an operating system?", options: ["A. Windows 11", "B. macOS", "C. Microsoft Office", "D. Linux"], answer: "C", marks: 1 },
          { id: 3, question: "To install Windows, you typically boot from:", options: ["A. The hard drive", "B. A USB drive or DVD", "C. The RAM", "D. The graphics card"], answer: "B", marks: 1 },
          { id: 4, question: "BIOS/UEFI allows you to:", options: ["A. Edit documents", "B. Change boot order", "C. Browse the internet", "D. Play games"], answer: "B", marks: 1 },
          { id: 5, question: "A device driver is:", options: ["A. A person who delivers computers", "B. Software that allows hardware to communicate with the OS", "C. A type of cable", "D. A cooling fan"], answer: "B", marks: 1 },
          { id: 6, question: "Disk partitioning is:", options: ["A. Breaking the disk physically", "B. Dividing storage into separate sections", "C. Removing the disk", "D. Cleaning the disk"], answer: "B", marks: 1 },
          { id: 7, question: "NTFS is a:", options: ["A. Network protocol", "B. File system used by Windows", "C. Type of RAM", "D. Virus"], answer: "B", marks: 1 },
          { id: 8, question: "A clean install means:", options: ["A. Wiping the dust off", "B. Installing OS on a formatted drive", "C. Upgrading from previous version", "D. Installing antivirus"], answer: "B", marks: 1 },
          { id: 9, question: "After OS installation, you should first:", options: ["A. Play games", "B. Install drivers and updates", "C. Delete system files", "D. Remove the hard drive"], answer: "B", marks: 1 },
          { id: 10, question: "Windows Product Key is:", options: ["A. A physical key", "B. A license code to activate Windows", "C. A keyboard shortcut", "D. A type of password"], answer: "B", marks: 1 },
          { id: 11, question: "Safe Mode starts Windows with:", options: ["A. All programs running", "B. Minimum drivers and services", "C. Maximum performance", "D. Internet only"], answer: "B", marks: 1 },
          { id: 12, question: "The Windows Registry is:", options: ["A. A list of installed programs only", "B. A database of system and application settings", "C. A type of file system", "D. A backup tool"], answer: "B", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 15,
        questions: [
          { id: 13, question: "List FOUR functions of an operating system.", marks: 4, answer: "1. Process management - running programs/applications. 2. Memory management - allocating RAM to programs. 3. File system management - organizing and storing files. 4. Device management - controlling hardware through drivers. 5. User interface - providing way to interact with computer. (any 4)" },
          { id: 14, question: "Explain the difference between a 32-bit and 64-bit operating system.", marks: 4, answer: "32-bit OS can address up to 4GB of RAM and run 32-bit programs only. 64-bit OS can address much more RAM (up to 18 exabytes theoretically), runs both 32-bit and 64-bit programs, and provides better performance for modern applications." },
          { id: 15, question: "Describe THREE things you should do after installing a new operating system.", marks: 3, answer: "1. Install device drivers for all hardware components. 2. Run Windows Update to get security patches and updates. 3. Install antivirus/security software. 4. Configure user accounts and passwords. 5. Install essential applications. (any 3)" },
          { id: 16, question: "What is the purpose of formatting a drive before OS installation?", marks: 4, answer: "Formatting prepares the drive by creating a new file system structure, erasing all previous data, checking for bad sectors, and setting up the necessary organization for the OS to store files. It ensures a clean installation without conflicts from previous data." }
        ]
      },
      {
        name: "Section C: Extended Response",
        marks: 13,
        questions: [
          { id: 17, question: "Describe the complete step-by-step process of installing Windows 10/11 on a new computer. Include all stages from preparation to first boot.", marks: 13, answer: "Preparation: 1. Create bootable USB with Windows installation media. 2. Backup any existing data if needed. Installation: 3. Insert USB and restart computer. 4. Enter BIOS/UEFI (Del/F2/F12) and set USB as first boot device. 5. Save and exit BIOS. 6. Boot from USB and select language/region settings. 7. Click 'Install Now'. 8. Enter product key or skip. 9. Accept license terms. 10. Choose 'Custom' for clean install. 11. Delete existing partitions and create new ones. 12. Select partition and click Next. 13. Wait for file copying and installation. 14. Computer restarts several times. 15. Set up user account, password, and preferences. 16. Configure privacy settings. Post-installation: 17. Install device drivers. 18. Run Windows Update. 19. Install applications." }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 5: Advanced Word Processing
  // ==========================================
  unit5: {
    id: "y12ict-unit5-test",
    title: "Unit 5 Test: Advanced Word Processing",
    duration: "45 minutes",
    totalMarks: 40,
    instructions: [
      "Answer ALL questions",
      "Section C is a practical task on the computer"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 12,
        questions: [
          { id: 1, question: "A word processor differs from a text editor because it:", options: ["A. Can only type text", "B. Provides formatting options", "C. Is always free", "D. Cannot save files"], answer: "B", marks: 1 },
          { id: 2, question: "To make text bold, the keyboard shortcut is:", options: ["A. Ctrl + I", "B. Ctrl + U", "C. Ctrl + B", "D. Ctrl + S"], answer: "C", marks: 1 },
          { id: 3, question: "A header appears:", options: ["A. At the bottom of each page", "B. At the top of each page", "C. Only on the first page", "D. Only on the last page"], answer: "B", marks: 1 },
          { id: 4, question: "Line spacing refers to:", options: ["A. Space between words", "B. Space between characters", "C. Space between lines of text", "D. Space between paragraphs only"], answer: "C", marks: 1 },
          { id: 5, question: "To insert a page break, use:", options: ["A. Enter key many times", "B. Ctrl + Enter", "C. Tab key", "D. Space bar"], answer: "B", marks: 1 },
          { id: 6, question: "Styles in Word are used to:", options: ["A. Add pictures", "B. Apply consistent formatting", "C. Check spelling", "D. Print documents"], answer: "B", marks: 1 },
          { id: 7, question: "The Format Painter tool:", options: ["A. Draws pictures", "B. Copies formatting from one text to another", "C. Paints the background", "D. Deletes formatting"], answer: "B", marks: 1 },
          { id: 8, question: "Indentation moves text:", options: ["A. Up or down", "B. Away from the margin", "C. To a new page", "D. To the center always"], answer: "B", marks: 1 },
          { id: 9, question: "A table in Word consists of:", options: ["A. Only rows", "B. Only columns", "C. Rows and columns forming cells", "D. Pictures only"], answer: "C", marks: 1 },
          { id: 10, question: "To find and replace text, use:", options: ["A. Ctrl + P", "B. Ctrl + H", "C. Ctrl + S", "D. Ctrl + N"], answer: "B", marks: 1 },
          { id: 11, question: "Bullets and numbering are found in the:", options: ["A. Insert tab", "B. Home tab", "C. View tab", "D. File tab"], answer: "B", marks: 1 },
          { id: 12, question: "To check spelling and grammar:", options: ["A. Press F7", "B. Press F1", "C. Press F5", "D. Press F12"], answer: "A", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 12,
        questions: [
          { id: 13, question: "List FOUR formatting features available on the Home tab ribbon.", marks: 4, answer: "Font type, Font size, Bold/Italic/Underline, Text color, Highlight color, Alignment, Line spacing, Bullets and numbering, Styles (any 4)" },
          { id: 14, question: "Explain the difference between Save and Save As.", marks: 4, answer: "Save (Ctrl+S) saves changes to the current file with the same name and location. Save As allows you to save the document with a new name, in a different location, or in a different file format, creating a new copy." },
          { id: 15, question: "Describe how to insert and format a table with 3 columns and 4 rows.", marks: 4, answer: "1. Click Insert tab > Table. 2. Select 3x4 grid or use 'Insert Table' dialog. 3. Type content in cells. 4. Select table to format. 5. Use Table Design tab for styles, borders, shading. 6. Use Table Layout tab to adjust column widths, row heights, alignment, merge/split cells." }
        ]
      },
      {
        name: "Section C: Practical Task",
        marks: 16,
        questions: [
          { id: 16, question: "Create a formal business letter with the following requirements:\n- Company letterhead with name and address\n- Date and recipient address\n- Proper salutation and closing\n- At least 2 paragraphs of body text\n- Your signature line\n- Apply: Header, Footer with page number, Different fonts for heading, 1.5 line spacing", marks: 16, answer: "Marking criteria: Letterhead properly formatted (3 marks), Date and addresses correct format (2 marks), Professional salutation and closing (2 marks), Body paragraphs well-structured (3 marks), Header with company name (2 marks), Footer with page number (2 marks), Appropriate fonts and sizes (1 mark), Line spacing correct (1 mark)" }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 6: Mail Merge & Citations
  // ==========================================
  unit6: {
    id: "y12ict-unit6-test",
    title: "Unit 6 Test: Mail Merge & Citations",
    duration: "45 minutes",
    totalMarks: 35,
    instructions: [
      "Answer ALL questions",
      "Section C requires computer access"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 10,
        questions: [
          { id: 1, question: "Mail merge is used to:", options: ["A. Send emails only", "B. Create personalized documents for multiple recipients", "C. Merge two documents into one", "D. Delete duplicate files"], answer: "B", marks: 1 },
          { id: 2, question: "The main document in mail merge contains:", options: ["A. The list of names only", "B. The template with merge fields", "C. Only pictures", "D. The final merged letters"], answer: "B", marks: 1 },
          { id: 3, question: "A data source in mail merge is:", options: ["A. The template letter", "B. A list of recipients and their information", "C. The printer", "D. The email program"], answer: "B", marks: 1 },
          { id: 4, question: "Merge fields are shown as:", options: ["A. Regular text", "B. Text in «angle brackets»", "C. Underlined text", "D. Bold text"], answer: "B", marks: 1 },
          { id: 5, question: "A citation is used to:", options: ["A. Add page numbers", "B. Give credit to sources", "C. Format text", "D. Insert pictures"], answer: "B", marks: 1 },
          { id: 6, question: "A bibliography is:", options: ["A. A list of chapters", "B. A list of all sources cited", "C. A type of font", "D. A page header"], answer: "B", marks: 1 },
          { id: 7, question: "APA, MLA, and Harvard are:", options: ["A. Programming languages", "B. Citation styles", "C. Font types", "D. File formats"], answer: "B", marks: 1 },
          { id: 8, question: "To insert a citation in Word:", options: ["A. Insert tab > Citation", "B. References tab > Insert Citation", "C. Home tab > Citation", "D. View tab > Citation"], answer: "B", marks: 1 },
          { id: 9, question: "A footnote appears:", options: ["A. At the top of the page", "B. At the bottom of the page", "C. At the end of the document", "D. In the margin"], answer: "B", marks: 1 },
          { id: 10, question: "An endnote appears:", options: ["A. At the top of each page", "B. At the bottom of each page", "C. At the end of the document", "D. In the header"], answer: "C", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 10,
        questions: [
          { id: 11, question: "List the FOUR main steps to create a mail merge document.", marks: 4, answer: "1. Create/open the main document (template). 2. Connect to or create the data source (recipient list). 3. Insert merge fields into the document. 4. Preview and complete the merge (print or create individual documents)." },
          { id: 12, question: "Explain why citations are important in academic writing.", marks: 3, answer: "Citations: 1. Give credit to original authors and avoid plagiarism. 2. Allow readers to verify information and find sources. 3. Demonstrate research quality and credibility. 4. Follow academic integrity standards." },
          { id: 13, question: "What information is typically needed for a book citation?", marks: 3, answer: "Author name(s), Book title, Publisher, Year of publication, Edition (if applicable), Place of publication (for some styles), Page numbers (for direct quotes)." }
        ]
      },
      {
        name: "Section C: Practical Task",
        marks: 15,
        questions: [
          { id: 14, question: "Create a mail merge letter inviting parents to a school meeting:\n1. Create a data source with at least 3 parents (Name, Address, Student Name)\n2. Create a letter template with merge fields\n3. Include meeting date, time, and purpose\n4. Merge and preview all letters\n5. Add one citation to a school policy document", marks: 15, answer: "Marking criteria: Data source correctly created (3 marks), All required fields included (2 marks), Letter professionally formatted (3 marks), Merge fields correctly inserted (3 marks), Merge completed successfully (2 marks), Citation properly added (2 marks)" }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 7: Spreadsheet Fundamentals
  // ==========================================
  unit7: {
    id: "y12ict-unit7-test",
    title: "Unit 7 Test: Spreadsheet Fundamentals",
    duration: "45 minutes",
    totalMarks: 40,
    instructions: [
      "Answer ALL questions",
      "Show all formulas in Section C"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 10,
        questions: [
          { id: 1, question: "A cell is identified by its:", options: ["A. Color", "B. Column letter and row number", "C. Size", "D. Content"], answer: "B", marks: 1 },
          { id: 2, question: "The formula =A1+B1 will:", options: ["A. Multiply A1 and B1", "B. Add A1 and B1", "C. Subtract B1 from A1", "D. Divide A1 by B1"], answer: "B", marks: 1 },
          { id: 3, question: "To make a cell reference absolute, use:", options: ["A. Parentheses ()", "B. Dollar sign $", "C. Asterisk *", "D. Percent %"], answer: "B", marks: 1 },
          { id: 4, question: "$A$1 is called:", options: ["A. Relative reference", "B. Absolute reference", "C. Mixed reference", "D. External reference"], answer: "B", marks: 1 },
          { id: 5, question: "The SUM function:", options: ["A. Counts cells", "B. Adds values", "C. Finds average", "D. Finds maximum"], answer: "B", marks: 1 },
          { id: 6, question: "=AVERAGE(A1:A10) calculates:", options: ["A. Total of A1 to A10", "B. Mean of A1 to A10", "C. Count of A1 to A10", "D. Maximum of A1 to A10"], answer: "B", marks: 1 },
          { id: 7, question: "To format a cell as currency:", options: ["A. Type $ before the number", "B. Use Number Format options", "C. Use bold", "D. Use underline"], answer: "B", marks: 1 },
          { id: 8, question: "A1:A10 represents:", options: ["A. Cell A1 only", "B. Cells A1 through A10", "C. Row 1 through 10", "D. Column A only"], answer: "B", marks: 1 },
          { id: 9, question: "The COUNT function:", options: ["A. Adds numbers", "B. Counts cells with numbers", "C. Counts all cells", "D. Counts text only"], answer: "B", marks: 1 },
          { id: 10, question: "To start a formula, type:", options: ["A. +", "B. -", "C. =", "D. #"], answer: "C", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 12,
        questions: [
          { id: 11, question: "Explain the difference between relative and absolute cell references with examples.", marks: 4, answer: "Relative reference (A1) changes when copied - if =A1 is copied down, it becomes =A2, =A3, etc. Absolute reference ($A$1) stays the same when copied - always refers to cell A1. Mixed reference ($A1 or A$1) locks either column or row. Use absolute when referring to a constant value like tax rate." },
          { id: 12, question: "Write the formula to calculate: Total of B2 to B10, then multiply by the tax rate in cell E1 (keep E1 fixed).", marks: 4, answer: "=SUM(B2:B10)*$E$1" },
          { id: 13, question: "List FOUR common spreadsheet functions and their purposes.", marks: 4, answer: "1. SUM - adds values in a range. 2. AVERAGE - calculates mean of values. 3. MAX - finds largest value. 4. MIN - finds smallest value. 5. COUNT - counts numeric cells. 6. IF - performs conditional logic. (any 4)" }
        ]
      },
      {
        name: "Section C: Practical Task",
        marks: 18,
        questions: [
          { id: 14, question: "Create a student grade book spreadsheet with:\n- Column A: Student names (5 students)\n- Columns B-D: Test 1, Test 2, Test 3 scores\n- Column E: Average (formula)\n- Column F: Grade using IF function (>=50 Pass, <50 Fail)\n- Row for class average of each test\n- Apply appropriate formatting (borders, headers, number formats)", marks: 18, answer: "Marking criteria: Student names entered (2 marks), Test scores entered correctly (2 marks), AVERAGE formula correct (3 marks), IF function for grade correct (4 marks), Class averages calculated (3 marks), Formatting applied professionally (4 marks). Example formulas: Average =AVERAGE(B2:D2), Grade =IF(E2>=50,\"Pass\",\"Fail\"), Class Avg =AVERAGE(B2:B6)" }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 8: Charts & Data Analysis
  // ==========================================
  unit8: {
    id: "y12ict-unit8-test",
    title: "Unit 8 Test: Charts & Data Analysis",
    duration: "45 minutes",
    totalMarks: 35,
    instructions: [
      "Answer ALL questions",
      "Section C requires creating charts on computer"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 8,
        questions: [
          { id: 1, question: "A pie chart is best for showing:", options: ["A. Trends over time", "B. Parts of a whole", "C. Comparison of many items", "D. Scatter data"], answer: "B", marks: 1 },
          { id: 2, question: "A line chart is best for showing:", options: ["A. Parts of a whole", "B. Trends over time", "C. Categories comparison", "D. Geographic data"], answer: "B", marks: 1 },
          { id: 3, question: "A bar chart is best for:", options: ["A. Showing percentages", "B. Comparing categories", "C. Showing continuous data", "D. Displaying addresses"], answer: "B", marks: 1 },
          { id: 4, question: "The X-axis is usually the:", options: ["A. Vertical axis", "B. Horizontal axis", "C. Title axis", "D. Legend axis"], answer: "B", marks: 1 },
          { id: 5, question: "A legend in a chart:", options: ["A. Shows the title", "B. Explains what each color/symbol represents", "C. Displays the data", "D. Is the chart border"], answer: "B", marks: 1 },
          { id: 6, question: "To create a chart, first:", options: ["A. Design the chart", "B. Select the data range", "C. Add a title", "D. Print the spreadsheet"], answer: "B", marks: 1 },
          { id: 7, question: "Data labels on a chart show:", options: ["A. The chart title", "B. Actual values on data points", "C. The file name", "D. The date"], answer: "B", marks: 1 },
          { id: 8, question: "A scatter plot shows:", options: ["A. Parts of a whole", "B. Relationship between two variables", "C. One category only", "D. Text data"], answer: "B", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 12,
        questions: [
          { id: 9, question: "Explain when you would use each chart type: pie chart, bar chart, line chart.", marks: 6, answer: "Pie chart: When showing parts of a whole (percentages), limited categories (usually <7), e.g., budget allocation. Bar chart: When comparing different categories, showing rankings, e.g., sales by product. Line chart: When showing trends over time, continuous data, e.g., monthly sales over a year." },
          { id: 10, question: "List FOUR elements that should be included in a well-designed chart.", marks: 4, answer: "1. Clear descriptive title. 2. Labeled axes (X and Y). 3. Legend explaining data series. 4. Appropriate scale. 5. Data labels when necessary. 6. Source of data if applicable. (any 4)" },
          { id: 11, question: "Describe how to change a chart type after it has been created.", marks: 2, answer: "1. Click on the chart to select it. 2. Go to Chart Design tab. 3. Click 'Change Chart Type'. 4. Select the new chart type from the gallery. 5. Click OK to apply." }
        ]
      },
      {
        name: "Section C: Practical Task",
        marks: 15,
        questions: [
          { id: 12, question: "Using the data below, create TWO appropriate charts:\nMonthly Sales Data:\n| Month | Product A | Product B |\n| Jan | 500 | 300 |\n| Feb | 600 | 350 |\n| Mar | 550 | 400 |\n| Apr | 700 | 450 |\n\n1. Create a LINE chart showing trends for both products\n2. Create a PIE chart showing total sales by product\n\nInclude: Titles, legends, axis labels, data labels", marks: 15, answer: "Marking criteria: Data entered correctly (2 marks), Line chart created with both products (3 marks), Line chart has title, legend, axis labels (2 marks), Pie chart created correctly (3 marks), Pie chart shows percentages/values (2 marks), Professional appearance (3 marks)" }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 9: Database Fundamentals
  // ==========================================
  unit9: {
    id: "y12ict-unit9-test",
    title: "Unit 9 Test: Database Fundamentals",
    duration: "45 minutes",
    totalMarks: 40,
    instructions: [
      "Answer ALL questions",
      "Write SQL queries using correct syntax"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 12,
        questions: [
          { id: 1, question: "A database is:", options: ["A. A single spreadsheet", "B. An organized collection of related data", "C. A word document", "D. A type of chart"], answer: "B", marks: 1 },
          { id: 2, question: "In a relational database, data is stored in:", options: ["A. Folders", "B. Tables", "C. Documents", "D. Slides"], answer: "B", marks: 1 },
          { id: 3, question: "A primary key is:", options: ["A. The first column", "B. A unique identifier for each record", "C. A password", "D. The table name"], answer: "B", marks: 1 },
          { id: 4, question: "A foreign key:", options: ["A. Is always the first field", "B. Links one table to another", "C. Is the same as primary key", "D. Cannot contain numbers"], answer: "B", marks: 1 },
          { id: 5, question: "A record in a database is:", options: ["A. A column", "B. A row containing related data", "C. The table name", "D. A database file"], answer: "B", marks: 1 },
          { id: 6, question: "A field in a database is:", options: ["A. A row", "B. A column/attribute", "C. The entire table", "D. A relationship"], answer: "B", marks: 1 },
          { id: 7, question: "Which relationship type means one record relates to many?", options: ["A. One-to-One", "B. One-to-Many", "C. Many-to-Many", "D. None"], answer: "B", marks: 1 },
          { id: 8, question: "A hierarchical database organizes data in:", options: ["A. Tables", "B. Tree-like structure", "C. Networks", "D. Random order"], answer: "B", marks: 1 },
          { id: 9, question: "SQL stands for:", options: ["A. Simple Query Language", "B. Structured Query Language", "C. Standard Question Language", "D. System Query Logic"], answer: "B", marks: 1 },
          { id: 10, question: "Data integrity means:", options: ["A. Data is colorful", "B. Data is accurate and consistent", "C. Data is large", "D. Data is encrypted"], answer: "B", marks: 1 },
          { id: 11, question: "Which is NOT a data type?", options: ["A. Text", "B. Number", "C. Date/Time", "D. Spreadsheet"], answer: "D", marks: 1 },
          { id: 12, question: "Normalization is:", options: ["A. Making data look normal", "B. Organizing data to reduce redundancy", "C. Deleting data", "D. Printing data"], answer: "B", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 15,
        questions: [
          { id: 13, question: "Compare the THREE types of database structures: Hierarchical, Network, and Relational.", marks: 6, answer: "Hierarchical: Tree structure, parent-child relationships, fast for specific queries, inflexible. Network: Similar to hierarchical but allows many-to-many relationships, complex navigation. Relational: Uses tables with rows and columns, most flexible, uses SQL, data linked through keys, most widely used today." },
          { id: 14, question: "Design a simple database for a library with at least 2 tables. Show table names, fields, data types, and relationships.", marks: 5, answer: "Books Table: BookID (Number, Primary Key), Title (Text), Author (Text), ISBN (Text), CategoryID (Number, Foreign Key). Categories Table: CategoryID (Number, Primary Key), CategoryName (Text), Description (Text). Relationship: One Category to Many Books (One-to-Many)" },
          { id: 15, question: "Explain THREE ways to maintain data integrity in a database.", marks: 4, answer: "1. Set appropriate data types (prevents wrong data entry). 2. Use primary keys (ensures unique records). 3. Set field validation rules (restricts invalid values). 4. Use referential integrity (maintains valid relationships). 5. Regular backups (protects against data loss). (any 3)" }
        ]
      },
      {
        name: "Section C: Extended Response",
        marks: 13,
        questions: [
          { id: 16, question: "A school needs a database to track students and their classes.\na) Design the database with appropriate tables, fields, and relationships (5 marks)\nb) Explain why you chose these tables and relationships (4 marks)\nc) List TWO advantages and TWO disadvantages of using a relational database for this purpose (4 marks)", marks: 13, answer: "a) Students Table: StudentID (PK), FirstName, LastName, DOB, Email. Classes Table: ClassID (PK), ClassName, TeacherID, Room. Enrollments Table: EnrollmentID (PK), StudentID (FK), ClassID (FK), EnrollmentDate. Teachers Table: TeacherID (PK), Name, Subject. b) Separate tables avoid data redundancy - student info stored once. Enrollments table handles many-to-many relationship between students and classes. Primary keys ensure unique identification. Foreign keys maintain referential integrity. c) Advantages: Reduces data redundancy, easy to query and update, maintains data integrity, scalable. Disadvantages: Can be complex to design, requires understanding of relationships, may be slower for very large datasets, requires specialized software." }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 10: Forms, Queries & Reports
  // ==========================================
  unit10: {
    id: "y12ict-unit10-test",
    title: "Unit 10 Test: Forms, Queries & Reports",
    duration: "45 minutes",
    totalMarks: 40,
    instructions: [
      "Answer ALL questions",
      "Write SQL queries with correct syntax",
      "Section C is a practical task"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 10,
        questions: [
          { id: 1, question: "A database form is used for:", options: ["A. Printing reports only", "B. Easy data entry and viewing", "C. Creating charts", "D. Writing documents"], answer: "B", marks: 1 },
          { id: 2, question: "The SQL command to retrieve data is:", options: ["A. INSERT", "B. UPDATE", "C. SELECT", "D. DELETE"], answer: "C", marks: 1 },
          { id: 3, question: "SELECT * FROM Students means:", options: ["A. Select nothing", "B. Select all columns from Students table", "C. Delete all students", "D. Update students"], answer: "B", marks: 1 },
          { id: 4, question: "The WHERE clause is used to:", options: ["A. Sort data", "B. Filter data based on conditions", "C. Group data", "D. Join tables"], answer: "B", marks: 1 },
          { id: 5, question: "ORDER BY is used to:", options: ["A. Filter records", "B. Sort results", "C. Delete records", "D. Create tables"], answer: "B", marks: 1 },
          { id: 6, question: "A database report is:", options: ["A. Raw data only", "B. Formatted output of data", "C. A blank form", "D. An error message"], answer: "B", marks: 1 },
          { id: 7, question: "GROUP BY is used with:", options: ["A. SELECT only", "B. Aggregate functions like COUNT, SUM", "C. DELETE only", "D. Form design"], answer: "B", marks: 1 },
          { id: 8, question: "To add a new record, use:", options: ["A. SELECT", "B. INSERT INTO", "C. UPDATE", "D. DELETE"], answer: "B", marks: 1 },
          { id: 9, question: "AND in a WHERE clause:", options: ["A. All conditions must be true", "B. Any condition can be true", "C. No conditions needed", "D. Deletes records"], answer: "A", marks: 1 },
          { id: 10, question: "OR in a WHERE clause:", options: ["A. All conditions must be true", "B. At least one condition must be true", "C. No conditions needed", "D. Updates records"], answer: "B", marks: 1 }
        ]
      },
      {
        name: "Section B: SQL Queries",
        marks: 12,
        questions: [
          { id: 11, question: "Write a SQL query to select all students whose age is greater than 15 from the Students table.", marks: 3, answer: "SELECT * FROM Students WHERE Age > 15;" },
          { id: 12, question: "Write a SQL query to select FirstName and LastName from Students table, sorted by LastName in ascending order.", marks: 3, answer: "SELECT FirstName, LastName FROM Students ORDER BY LastName ASC;" },
          { id: 13, question: "Write a SQL query to count how many students are in each class from a table with StudentID, Name, and Class fields.", marks: 3, answer: "SELECT Class, COUNT(*) AS StudentCount FROM Students GROUP BY Class;" },
          { id: 14, question: "Write a SQL query to select students who are either in Class 'Year 12' OR have a GPA greater than 3.5.", marks: 3, answer: "SELECT * FROM Students WHERE Class = 'Year 12' OR GPA > 3.5;" }
        ]
      },
      {
        name: "Section C: Practical Task",
        marks: 18,
        questions: [
          { id: 15, question: "Using a database application (Access or similar):\n1. Create a Products table with: ProductID (Primary Key), ProductName, Category, Price, StockQuantity\n2. Enter at least 5 products\n3. Create a form for data entry\n4. Create a query to show products with Price > 50\n5. Create a report grouped by Category showing total stock value (Price × Quantity)", marks: 18, answer: "Marking criteria: Table created correctly with proper data types (4 marks), 5+ products entered (2 marks), Form created and functional (3 marks), Query correct with criteria (4 marks), Report grouped correctly with calculated field (5 marks). Stock value formula: Price * StockQuantity" }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 11: Digital Image Processing
  // ==========================================
  unit11: {
    id: "y12ict-unit11-test",
    title: "Unit 11 Test: Digital Image Processing",
    duration: "45 minutes",
    totalMarks: 35,
    instructions: [
      "Answer ALL questions",
      "Section C requires image editing software"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 10,
        questions: [
          { id: 1, question: "JPEG is best for:", options: ["A. Images with transparency", "B. Photographs with many colors", "C. Simple graphics", "D. Animated images"], answer: "B", marks: 1 },
          { id: 2, question: "PNG supports:", options: ["A. Animation", "B. Transparency", "C. Video", "D. Audio"], answer: "B", marks: 1 },
          { id: 3, question: "GIF is commonly used for:", options: ["A. High-quality photos", "B. Simple animations", "C. Large images", "D. Print media"], answer: "B", marks: 1 },
          { id: 4, question: "Resolution is measured in:", options: ["A. Bytes", "B. Pixels", "C. Colors", "D. Layers"], answer: "B", marks: 1 },
          { id: 5, question: "Cropping an image:", options: ["A. Increases its size", "B. Removes unwanted parts", "C. Adds effects", "D. Changes its format"], answer: "B", marks: 1 },
          { id: 6, question: "Image compression:", options: ["A. Increases file size", "B. Reduces file size", "C. Adds colors", "D. Removes pixels"], answer: "B", marks: 1 },
          { id: 7, question: "A collage is:", options: ["A. A single photo", "B. Multiple images combined", "C. A video format", "D. An animation"], answer: "B", marks: 1 },
          { id: 8, question: "A panorama is:", options: ["A. A portrait photo", "B. A wide-angle combined image", "C. A thumbnail", "D. A logo"], answer: "B", marks: 1 },
          { id: 9, question: "GIMP is:", options: ["A. A database program", "B. Free image editing software", "C. A web browser", "D. An operating system"], answer: "B", marks: 1 },
          { id: 10, question: "Layers in image editing allow:", options: ["A. Faster saving", "B. Editing parts independently", "C. Smaller files", "D. Auto-corrections"], answer: "B", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 10,
        questions: [
          { id: 11, question: "Compare JPEG, PNG, and GIF formats. When would you use each?", marks: 6, answer: "JPEG: Best for photographs with many colors, lossy compression, small file size, no transparency. Use for: photos, web images. PNG: Lossless compression, supports transparency, larger files. Use for: logos, graphics needing transparency, screenshots. GIF: Limited to 256 colors, supports animation and transparency. Use for: simple animations, icons, graphics with few colors." },
          { id: 12, question: "List FOUR common image editing operations and describe each.", marks: 4, answer: "1. Crop - remove unwanted parts of image. 2. Resize - change image dimensions. 3. Adjust brightness/contrast - modify light levels. 4. Color correction - adjust color balance. 5. Filters/Effects - apply artistic modifications. 6. Layers - work with image elements independently. (any 4)" }
        ]
      },
      {
        name: "Section C: Practical Task",
        marks: 15,
        questions: [
          { id: 13, question: "Using image editing software:\n1. Create a collage using 3-4 images\n2. Add a title text overlay\n3. Apply at least 2 different effects or adjustments\n4. Resize to 800x600 pixels\n5. Save in both JPEG and PNG formats\n\nSubmit both files and describe why you chose each format.", marks: 15, answer: "Marking criteria: Collage with 3-4 images arranged creatively (4 marks), Title text added and readable (2 marks), Two effects/adjustments applied (3 marks), Correctly resized to 800x600 (2 marks), Both formats saved correctly (2 marks), Explanation of format choices (2 marks)" }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 12: Programming Fundamentals
  // ==========================================
  unit12: {
    id: "y12ict-unit12-test",
    title: "Unit 12 Test: Programming Fundamentals",
    duration: "45 minutes",
    totalMarks: 40,
    instructions: [
      "Answer ALL questions",
      "Write code using Python syntax",
      "Show expected output where asked"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 10,
        questions: [
          { id: 1, question: "A variable is:", options: ["A. A fixed value", "B. A named storage location for data", "C. A type of loop", "D. A function name"], answer: "B", marks: 1 },
          { id: 2, question: "Which is a valid Python variable name?", options: ["A. 2ndName", "B. second-name", "C. second_name", "D. second name"], answer: "C", marks: 1 },
          { id: 3, question: "In structured programming, sequence means:", options: ["A. Repeating code", "B. Making decisions", "C. Executing instructions in order", "D. Storing data"], answer: "C", marks: 1 },
          { id: 4, question: "Selection in programming uses:", options: ["A. for loops", "B. if/else statements", "C. print statements", "D. variable declarations"], answer: "B", marks: 1 },
          { id: 5, question: "Repetition is achieved using:", options: ["A. if statements", "B. loops (for, while)", "C. functions", "D. variables"], answer: "B", marks: 1 },
          { id: 6, question: "An array (list in Python) is:", options: ["A. A single value", "B. A collection of values", "C. A loop", "D. A condition"], answer: "B", marks: 1 },
          { id: 7, question: "The output of print(5 + 3) is:", options: ["A. 53", "B. 8", "C. 5 + 3", "D. Error"], answer: "B", marks: 1 },
          { id: 8, question: "A function is:", options: ["A. A variable", "B. A reusable block of code", "C. A data type", "D. A file type"], answer: "B", marks: 1 },
          { id: 9, question: "The == operator:", options: ["A. Assigns a value", "B. Compares for equality", "C. Adds numbers", "D. Creates a variable"], answer: "B", marks: 1 },
          { id: 10, question: "To get user input in Python:", options: ["A. print()", "B. input()", "C. get()", "D. read()"], answer: "B", marks: 1 }
        ]
      },
      {
        name: "Section B: Code Analysis",
        marks: 12,
        questions: [
          { id: 11, question: "What is the output of this code?\n\nx = 10\ny = 5\nif x > y:\n    print('X is larger')\nelse:\n    print('Y is larger')", marks: 3, answer: "X is larger" },
          { id: 12, question: "What is the output of this code?\n\nfor i in range(3):\n    print(i * 2)", marks: 3, answer: "0\n2\n4" },
          { id: 13, question: "What is the output of this code?\n\nnumbers = [1, 2, 3, 4, 5]\ntotal = 0\nfor num in numbers:\n    total = total + num\nprint(total)", marks: 3, answer: "15" },
          { id: 14, question: "Find and fix the error in this code:\n\nage = input('Enter age: ')\nif age >= 18:\n    print('Adult')", marks: 3, answer: "Error: input() returns a string, but we're comparing to an integer. Fix: age = int(input('Enter age: '))" }
        ]
      },
      {
        name: "Section C: Coding Tasks",
        marks: 18,
        questions: [
          { id: 15, question: "Write a Python program that:\n1. Asks the user for their name\n2. Asks for 3 test scores\n3. Calculates and displays the average\n4. Displays 'Pass' if average >= 50, otherwise 'Fail'", marks: 10, answer: "name = input('Enter your name: ')\nscore1 = int(input('Enter score 1: '))\nscore2 = int(input('Enter score 2: '))\nscore3 = int(input('Enter score 3: '))\naverage = (score1 + score2 + score3) / 3\nprint(f'{name}, your average is: {average}')\nif average >= 50:\n    print('Pass')\nelse:\n    print('Fail')" },
          { id: 16, question: "Write a Python program that:\n1. Creates a list of 5 student names\n2. Uses a loop to print each name with a number\n(e.g., 1. John, 2. Mary, etc.)", marks: 8, answer: "students = ['John', 'Mary', 'Peter', 'Sarah', 'David']\nfor i in range(len(students)):\n    print(f'{i+1}. {students[i]}')\n\n# Alternative using enumerate:\nfor index, name in enumerate(students, 1):\n    print(f'{index}. {name}')" }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 13: Computer Networks
  // ==========================================
  unit13: {
    id: "y12ict-unit13-test",
    title: "Unit 13 Test: Computer Networks",
    duration: "45 minutes",
    totalMarks: 40,
    instructions: [
      "Answer ALL questions",
      "Draw diagrams where required"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 12,
        questions: [
          { id: 1, question: "A LAN is:", options: ["A. A global network", "B. A local area network", "C. A wireless device", "D. A protocol"], answer: "B", marks: 1 },
          { id: 2, question: "TCP/IP stands for:", options: ["A. Transfer Control Protocol/Internet Protocol", "B. Transmission Control Protocol/Internet Protocol", "C. Technical Computer Protocol/Internet Protocol", "D. Total Control Protocol/Internet Protocol"], answer: "B", marks: 1 },
          { id: 3, question: "An IP address:", options: ["A. Names the computer user", "B. Uniquely identifies a device on a network", "C. Is the same as MAC address", "D. Is optional"], answer: "B", marks: 1 },
          { id: 4, question: "DNS converts:", options: ["A. Files to folders", "B. Domain names to IP addresses", "C. Text to images", "D. Videos to audio"], answer: "B", marks: 1 },
          { id: 5, question: "A router:", options: ["A. Stores files", "B. Connects different networks", "C. Only connects printers", "D. Is the same as a switch"], answer: "B", marks: 1 },
          { id: 6, question: "A switch:", options: ["A. Connects devices within a network", "B. Connects to the internet", "C. Stores data", "D. Provides wireless access only"], answer: "A", marks: 1 },
          { id: 7, question: "CAT6 is a type of:", options: ["A. Wireless standard", "B. Network cable", "C. Protocol", "D. IP address"], answer: "B", marks: 1 },
          { id: 8, question: "RJ-45 is a:", options: ["A. Cable type", "B. Connector type", "C. Protocol", "D. Router model"], answer: "B", marks: 1 },
          { id: 9, question: "A WAN covers:", options: ["A. A single room", "B. A single building", "C. A large geographic area", "D. One computer only"], answer: "C", marks: 1 },
          { id: 10, question: "The default gateway is:", options: ["A. The computer name", "B. The router address for internet access", "C. A file server", "D. A cable type"], answer: "B", marks: 1 },
          { id: 11, question: "Bandwidth measures:", options: ["A. Physical cable size", "B. Data transfer capacity", "C. Number of computers", "D. Power consumption"], answer: "B", marks: 1 },
          { id: 12, question: "A NIC is:", options: ["A. Network Interface Card", "B. Network Internet Connection", "C. New Internet Cable", "D. National Internet Center"], answer: "A", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 15,
        questions: [
          { id: 13, question: "Explain the role of TCP/IP in computer networks.", marks: 4, answer: "TCP/IP is the fundamental protocol suite for internet communication. TCP (Transmission Control Protocol) breaks data into packets, ensures reliable delivery, and reassembles packets at destination. IP (Internet Protocol) handles addressing and routing of packets across networks. Together they enable devices to communicate regardless of their underlying hardware." },
          { id: 14, question: "Compare the functions of a router and a switch.", marks: 4, answer: "Router: Connects different networks (e.g., home network to internet), uses IP addresses, makes routing decisions, provides NAT and DHCP services, works at Network layer. Switch: Connects devices within the same network, uses MAC addresses, creates separate collision domains, faster than hubs, works at Data Link layer." },
          { id: 15, question: "Draw and label a simple network diagram showing: 3 computers, 1 switch, 1 router, and internet connection.", marks: 4, answer: "Diagram should show: Internet cloud → Router → Switch → 3 Computers. Labels needed: Internet, Router, Switch, PC1/PC2/PC3. Connections shown with lines representing cables." },
          { id: 16, question: "List THREE benefits of using a computer network in an office.", marks: 3, answer: "1. Resource sharing (printers, files, internet connection). 2. Communication (email, instant messaging, video calls). 3. Centralized data storage and backup. 4. Cost savings (shared resources). 5. Collaboration on documents. (any 3)" }
        ]
      },
      {
        name: "Section C: Extended Response",
        marks: 13,
        questions: [
          { id: 17, question: "A small business wants to set up a network for 10 computers.\na) List all the hardware they would need (5 marks)\nb) Describe the steps to configure basic network settings on a computer (4 marks)\nc) Explain how DNS helps employees access websites (4 marks)", marks: 13, answer: "a) Hardware needed: 10 Network Interface Cards (if not built-in), 1 Switch (minimum 12 ports), 1 Router, Network cables (CAT5e/CAT6) for each computer, Modem (if internet from ISP), Optional: Server for file sharing, Wireless Access Point. b) Steps: 1. Open Network Settings/Control Panel. 2. Select network adapter. 3. Configure IP settings (automatic DHCP or manual). 4. Set subnet mask (e.g., 255.255.255.0). 5. Set default gateway (router IP). 6. Set DNS servers (ISP or public like 8.8.8.8). 7. Test connection. c) DNS: When employee types website (e.g., www.example.com), computer sends request to DNS server. DNS server looks up domain name in its database. Returns corresponding IP address (e.g., 93.184.216.34). Computer connects to that IP address. Without DNS, users would need to remember IP addresses for every website." }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 14: Web Page Creation
  // ==========================================
  unit14: {
    id: "y12ict-unit14-test",
    title: "Unit 14 Test: Web Page Creation",
    duration: "45 minutes",
    totalMarks: 40,
    instructions: [
      "Answer ALL questions",
      "Section C requires creating a website"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 10,
        questions: [
          { id: 1, question: "A CMS stands for:", options: ["A. Computer Management System", "B. Content Management System", "C. Central Media Server", "D. Coded Message Service"], answer: "B", marks: 1 },
          { id: 2, question: "WordPress is an example of:", options: ["A. Operating system", "B. CMS", "C. Programming language", "D. Database"], answer: "B", marks: 1 },
          { id: 3, question: "Web hosting provides:", options: ["A. Internet connection only", "B. Server space for websites", "C. Computer repairs", "D. Email only"], answer: "B", marks: 1 },
          { id: 4, question: "A domain name is:", options: ["A. An IP address", "B. The website's address (e.g., www.example.com)", "C. A username", "D. A password"], answer: "B", marks: 1 },
          { id: 5, question: "HTML is used to:", options: ["A. Style web pages", "B. Structure web content", "C. Program databases", "D. Send emails"], answer: "B", marks: 1 },
          { id: 6, question: "CSS is used to:", options: ["A. Structure content", "B. Style and format web pages", "C. Create databases", "D. Write programs"], answer: "B", marks: 1 },
          { id: 7, question: "A template in CMS:", options: ["A. Must be created from scratch", "B. Provides a pre-designed layout", "C. Is required for every page", "D. Cannot be modified"], answer: "B", marks: 1 },
          { id: 8, question: "SEO stands for:", options: ["A. Search Engine Optimization", "B. Site Enhancement Option", "C. Server Entry Operation", "D. System Error Output"], answer: "A", marks: 1 },
          { id: 9, question: "A hyperlink:", options: ["A. Is only for images", "B. Connects to other pages or resources", "C. Must be blue", "D. Cannot open in new windows"], answer: "B", marks: 1 },
          { id: 10, question: "Responsive design means:", options: ["A. Website loads quickly", "B. Website adapts to different screen sizes", "C. Website responds to emails", "D. Website has fast servers"], answer: "B", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 12,
        questions: [
          { id: 11, question: "List FOUR advantages of using a CMS for website creation.", marks: 4, answer: "1. No coding knowledge required - easy to use. 2. Pre-designed templates available. 3. Easy content updates without technical skills. 4. Built-in features (plugins, SEO tools). 5. Multiple users can manage content. 6. Regular updates and security patches. (any 4)" },
          { id: 12, question: "Describe the steps to plan a website layout.", marks: 4, answer: "1. Define purpose and target audience. 2. Plan navigation structure (menu items). 3. Sketch page layouts (wireframes). 4. Decide on number of pages needed. 5. Plan content for each page. 6. Choose color scheme and fonts. 7. Identify images and media needed." },
          { id: 13, question: "Explain the difference between free and paid web hosting.", marks: 4, answer: "Free hosting: No cost, limited storage/bandwidth, may show ads, limited support, subdomain only (e.g., yoursite.freehost.com), fewer features. Paid hosting: Monthly/yearly cost, more storage and bandwidth, no forced ads, technical support available, custom domain name, more features and control, better reliability and speed." }
        ]
      },
      {
        name: "Section C: Practical Task",
        marks: 18,
        questions: [
          { id: 14, question: "Create a website for a school club with:\n1. At least 3 pages (Home, About, Contact)\n2. Navigation menu linking all pages\n3. Images on at least one page\n4. Club name as header on all pages\n5. Contact form or information on Contact page\n6. Consistent color scheme throughout\n\nSubmit: Website URL or screenshots of all pages.", marks: 18, answer: "Marking criteria: Three pages created (3 marks), Navigation works correctly (3 marks), Images properly inserted and sized (2 marks), Consistent header/branding (2 marks), Contact information/form included (3 marks), Consistent color scheme/design (3 marks), Overall professional appearance (2 marks)" }
        ]
      }
    ]
  },

  // ==========================================
  // UNIT 15: Internet Security & Safety
  // ==========================================
  unit15: {
    id: "y12ict-unit15-test",
    title: "Unit 15 Test: Internet Security & Safety",
    duration: "45 minutes",
    totalMarks: 40,
    instructions: [
      "Answer ALL questions",
      "Provide examples where possible"
    ],
    sections: [
      {
        name: "Section A: Multiple Choice",
        marks: 12,
        questions: [
          { id: 1, question: "Phishing is:", options: ["A. A type of fishing", "B. Fake emails/websites to steal information", "C. A security software", "D. A type of virus"], answer: "B", marks: 1 },
          { id: 2, question: "Malware includes:", options: ["A. Hardware components", "B. Viruses, worms, trojans, ransomware", "C. Operating systems", "D. Web browsers"], answer: "B", marks: 1 },
          { id: 3, question: "Ransomware:", options: ["A. Speeds up computers", "B. Encrypts files and demands payment", "C. Provides free software", "D. Protects data"], answer: "B", marks: 1 },
          { id: 4, question: "A firewall:", options: ["A. Heats the computer", "B. Blocks unauthorized network access", "C. Stores passwords", "D. Is a physical wall"], answer: "B", marks: 1 },
          { id: 5, question: "HTTPS indicates:", options: ["A. Slow connection", "B. Secure encrypted connection", "C. High speed transfer", "D. Free website"], answer: "B", marks: 1 },
          { id: 6, question: "Two-factor authentication requires:", options: ["A. Two passwords", "B. Two methods of verification", "C. Two computers", "D. Two users"], answer: "B", marks: 1 },
          { id: 7, question: "A strong password should have:", options: ["A. Only letters", "B. Mix of letters, numbers, symbols", "C. Personal information", "D. Common words"], answer: "B", marks: 1 },
          { id: 8, question: "Social engineering attacks target:", options: ["A. Hardware", "B. Human psychology", "C. Networks only", "D. Operating systems"], answer: "B", marks: 1 },
          { id: 9, question: "Data backup is important because:", options: ["A. It speeds up computer", "B. It protects against data loss", "C. It blocks viruses", "D. It increases storage"], answer: "B", marks: 1 },
          { id: 10, question: "Antivirus software:", options: ["A. Creates viruses", "B. Detects and removes malware", "C. Only blocks websites", "D. Speeds up internet"], answer: "B", marks: 1 },
          { id: 11, question: "A DDoS attack:", options: ["A. Steals passwords", "B. Overwhelms servers with traffic", "C. Encrypts files", "D. Installs software"], answer: "B", marks: 1 },
          { id: 12, question: "Cyberbullying is:", options: ["A. A type of virus", "B. Online harassment or intimidation", "C. A security software", "D. A network protocol"], answer: "B", marks: 1 }
        ]
      },
      {
        name: "Section B: Short Answer",
        marks: 15,
        questions: [
          { id: 13, question: "Describe FIVE cybersecurity best practices for individuals.", marks: 5, answer: "1. Use strong, unique passwords for each account. 2. Enable two-factor authentication. 3. Keep software and systems updated. 4. Don't click suspicious links or attachments. 5. Use antivirus software and firewalls. 6. Backup data regularly. 7. Be careful with personal information online. 8. Verify HTTPS before entering sensitive data. (any 5)" },
          { id: 14, question: "Explain the impact of cybercrimes on organizations.", marks: 5, answer: "Financial loss: Cost of recovery, ransom payments, lost business. Reputation damage: Loss of customer trust and confidence. Legal consequences: Fines for data breaches, lawsuits. Operational disruption: Systems down, inability to work. Data loss: Loss of valuable company and customer data. Employee impact: Job losses, decreased morale. Competitive disadvantage: Stolen intellectual property." },
          { id: 15, question: "What is data security and why is it important?", marks: 5, answer: "Data security involves protecting digital information from unauthorized access, corruption, or theft. Importance: 1. Protects personal information and privacy. 2. Maintains business confidentiality. 3. Ensures compliance with regulations (GDPR, etc.). 4. Prevents financial fraud and identity theft. 5. Maintains trust with customers and partners. 6. Protects intellectual property." }
        ]
      },
      {
        name: "Section C: Extended Response",
        marks: 13,
        questions: [
          { id: 16, question: "A company's employee received a suspicious email claiming to be from the IT department asking them to verify their password.\na) Identify what type of attack this is and explain how it works (4 marks)\nb) List FOUR signs that indicate an email might be a phishing attempt (4 marks)\nc) Describe what the employee should do and what security measures the company should implement (5 marks)", marks: 13, answer: "a) This is a phishing attack. Attackers create emails that appear to be from legitimate sources (IT department, banks, etc.) to trick users into revealing sensitive information like passwords, credit card numbers, or personal data. They may include links to fake websites that look authentic. b) Signs of phishing: 1. Sender email doesn't match official domain. 2. Urgent or threatening language. 3. Generic greetings ('Dear User'). 4. Spelling and grammar errors. 5. Suspicious links (hover to see actual URL). 6. Requests for sensitive information. 7. Unexpected attachments. (any 4) c) Employee should: Report email to IT department, do not click links or provide information, delete the email. Company should: Implement email filtering, conduct security awareness training, use two-factor authentication, establish clear IT communication policies, have incident response procedures, use anti-phishing tools, regular security audits." }
        ]
      }
    ]
  }
};

export default year12ICTUnitTests;
